//import SlButton from '@shoelace-style/shoelace/dist/react/button';
//import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
//import { useState } from 'react'; 
import SlCard from '@shoelace-style/shoelace/dist/react/card';

const css = `
.card-image-current-projects {
    width: 100%;
    padding: 20px;
    border: 2px solid var(--sl-color-gray-300);
    margin: 1vw;
    margin-bottom: 40px;
  }

  .card-image-current-projects::part(image) {
    flex-direction: column;
  }

  .card-image-current-projects:hover {
    border: 2px solid var(--sl-color-neutral-1000);
    box-shadow: 2px 2px 2px var(--sl-color-gray-400);
    cursor: pointer;
  }
  .card-title {
    text-align: center;
  }

  .feature-text__paragraphs {
    text-align: left;
    margin: 10px;
}


`;



const Currentprojects = () => {
/* const [open, setOpen] = useState(false);
    const _onClick = (one, two) => {
        console.log(one)
        console.log(two)
        console.log(one.currentTarget.id)
        setOpen(true)
    } */
    return (
        <>
{/* <SlDialog label="Dialog" open={open} onSlAfterHide={() => setOpen(false)}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        <SlButton slot="footer" variant="primary" onClick={() => setOpen(false)}>
          Close
        </SlButton>
      </SlDialog>  */}
        <h2 className="feature-text__paragraphs">San Jose, CA. 4 Units<br/>Multifamily addition. Two story Unit + ADU + JADU</h2>
        <h5 className="feature-text__paragraphs">Status: Under Construction (100%)</h5>
        <SlCard className="card-image-current-projects" id={"sanjose"} >
          <img
            slot="image"
            src="./images/sanjose.png"
            alt="JADU."
          />
         {/*  <img
            slot="image"
            src="./images/sanjoseproforma.png"
            alt="JADU."
          /> */}
          <div className="card-title">
            San Jose, CA
          </div>
        </SlCard>

        <h2 className="feature-text__paragraphs">Redwood City, CA. 4 Units <br/>Two story Duplex + 2 ADUs</h2>
        <h5 className="feature-text__paragraphs">Status: Under Construction (5%)</h5>
        <SlCard className="card-image-current-projects" id={"redwood"} >
          <img
            slot="image"
            src="./images/redwood.png"
            alt="JADU."
          />
         {/*  <img
            slot="image"
            src="./images/redwoodproforma.png"
            alt="JADU."
          /> */}
          <div className="card-title">
            Redwood City, CA
          </div>
        </SlCard>
        <h2 className="feature-text__paragraphs">Salinas, CA. 4 Units<br/>Multifamily addition. ADU + JADU + Garage Conversion</h2>
        <h5 className="feature-text__paragraphs">Status: Under Construction (90%)</h5>
        <SlCard className="card-image-current-projects" id={"redwood"} >
          <img
            slot="image"
            src="./images/salinas.png"
            alt="JADU."
          />
         {/*  <img
            slot="image"
            src="./images/salinasproforma.png"
            alt="JADU."
          /> */}
          <div className="card-title">
            Salinas, CA
          </div>
        </SlCard>
        <h2 className="feature-text__paragraphs">Redwood, CA. 6 Units<br/>Townhomes 6 Units  Three Stories</h2>
        <h5 className="feature-text__paragraphs">Status: Under Permit Application (10%)</h5>
        <SlCard className="card-image-current-projects" id={"redwood"} >
          <img
            slot="image"
            src="./images/townhomeredwood.png"
            alt="JADU."
          />
          <div className="card-title">
            Redwood City, CA
          </div>
        </SlCard>


        <br/>
        <br/>
        <h2 className={"title-centered"}>
            Interested in investing in one of the current/next development projects or just want more info?
        </h2>
        <p>
             If you're an accredited investor and like the idea of allocating capital for build-to-sell and/or build-to-rent projects in the Bay Are, CA area - send me an <a href="mailto: admin@homekeepy.com">email</a> to begin the conversation!
        </p>
        {/* <p>
            Property was purchased back in 2020.  
        </p> */}

    
        <style>{css}</style>
      </>
    )
};

export default Currentprojects;